import { render } from "./AdicionarCampeonatoModal.vue?vue&type=template&id=60697a11&scoped=true"
import script from "./AdicionarCampeonatoModal.vue?vue&type=script&lang=js"
export * from "./AdicionarCampeonatoModal.vue?vue&type=script&lang=js"

import "./AdicionarCampeonatoModal.vue?vue&type=style&index=0&id=60697a11&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60697a11"]])

export default __exports__